export default (theme) => ({
    fieldGroup: {
        borderBottom: "1px solid #adaeaf",
        padding: "10px 0px"
    },
    attorneyDetailHead: {
        ...theme.typography.t20,
        ...theme.typography.medium,
    }
});